module.exports = __webpack_public_path__ + "img/fieldwork-HiRes.e81c3128.jpg";